export enum AssetCategory {
  VIDEO_TEMPLATES = 'video_templates',
  STOCK_VIDEOS = 'stock_videos',
  AUDIOS = 'audios',
  GRAPHICS = 'graphics'
}

export enum LicenseSource {
  ENVATO = 'envato',
  SHUTTERSTOCK = 'shutterstock',
  CUSTOM = 'custom',
  OTHER = 'other'
}

export interface License {
  id?: number
  source: LicenseSource
  license_file?: File | string
  license_url?: string
  license_text?: string
  download_url?: string
  purchased_date?: string
  expires_at?: string | null
}

export interface AssetMetadata {
  size: number
  file_type: string
  mime_type: string
  duration?: number // for videos/audios
  resolution?: string // for videos/images
  frame_rate?: number // for videos
  bitrate?: number // for videos/audios
  channels?: number // for audios
  sample_rate?: number // for audios
}

export interface Asset {
  id?: number
  name: string
  category: AssetCategory
  category_name?: string // Actual category name from API
  category_object?: any // Full category object from API
  description?: string
  tags: string[]
  thumbnails: string[] // URLs to thumbnail images
  zip_file?: File | string
  zip_file_url?: string
  licenses: License[]
  metadata: AssetMetadata
  source_platform?: LicenseSource | string // Can be enum or string from API
  platform_object?: any // Full platform object from API
  source_url?: string
  uploaded_at?: string
  uploaded_by?: number
  download_count?: number
  status?: 'pending' | 'uploading' | 'completed' | 'failed'
  upload_progress?: number
  created_at?: string
  updated_at?: string
}

export interface UploadChunk {
  chunk_index: number
  total_chunks: number
  chunk_data: Blob
  file_name: string
  file_size: number
  file_hash?: string
}

export interface UploadProgress {
  asset_id?: number
  file_name: string
  uploaded_bytes: number
  total_bytes: number
  percentage: number
  status: 'pending' | 'uploading' | 'resuming' | 'processing' | 'completed' | 'failed'
  error?: string
}

export interface DownloadRequest {
  asset_id: number
  workspace_id?: number
  project_ids?: number[]
  download_reason?: string
}

export interface AssetFilter {
  category?: AssetCategory
  tags?: string[]
  search?: string
  source_platform?: LicenseSource
  date_from?: string
  date_to?: string
  page?: number
  per_page?: number
}

